<!--
*****************************************************************************
*File : App.vue
*Module : Dashboard Frontend
*Purpose : Returns the current user logged in .
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
import { Role } from '@/role';
import { router } from '@/router';

export default {
    name: 'App',
    data () {
        return {
            currentUser: null
        };
    },
    computed: {
        isAdmin () {
            return this.currentUser && this.currentUser[0]['roles'].replace(/['['\]]/g,'') === Role.Admin;            
        }
    },
    methods: {
        logout () {
            router.push('/');
        }
    }
};
</script>

<style lang="scss">
@import "./assets/css/app";
</style>
